module.exports = __webpack_public_path__ + "img/icons.a4376c27.svg";